import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { CatalogDelayCode } from "../models/CatalogDelayCode";

export const upsertDelay = async (
	delayCode: CatalogDelayCode,
	cascadeIsActive = false,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{
			name: "DelayAreaAssetId",
			value: delayCode.DelayAreaAssetId,
		},
		{ name: "DelayCodeId", value: delayCode.DelayCodeId },
		{ name: "DelayCodeName", value: delayCode.DelayCodeName },
		{
			name: "ParentDelayCodeId",
			value:
				delayCode.ParentDelayCodeId === 0 ? null : delayCode.ParentDelayCodeId,
		},
		{
			name: "DefaultDelayCategoryId",
			value: delayCode.DelayCategoryId,
		},
		{
			name: "IsActive",
			value: delayCode.IsActive,
		},
		{
			name: "QuickButtonEnabled",
			value: delayCode.QuickButtonEnabled,
		},
	];
	if (cascadeIsActive) {
		parameters.push({ name: "CascadeIsActive", value: true });
	}

	return await apiService.callV2(`[DEL].[UpsertDelayCode]`, parameters);
};

export const deleteDelay = async (delayCodeId: number) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "DelayCodeId", value: delayCodeId },
	];

	return await apiService.callV2(`[DEL].[DeleteDelayCode]`, parameters);
};

export const getDelays = async (assetId?: number, includeInactive = false) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];
	if (assetId) parameters.push({ name: "DelayAreaAssetId", value: assetId });
	if (includeInactive)
		parameters.push({ name: "IncludeInactive", value: true });

	return await apiService.callV2("[DEL].[GetDelayCodes]", parameters);
};

export const getDelay = async (DelayCodeId: number) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "DelayCodeId", value: DelayCodeId },
	];

	return await apiService.callV2("[DEL].[GetDelayCode]", parameters);
};

export const reorderDelays = async (
	DelayCodeId: (string | number)[],
	AboveDelayCodeId: number | null,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{
			name: "DelayCodeId",
			value: DelayCodeId.join(","),
		},
		{ name: "AboveDelayCodeId", value: AboveDelayCodeId },
	];

	return await apiService.callV2("[DEL].[ChangeParentDelayCode]", parameters);
};

export const moveDelayCode = async (
	DelayCodeId: number | null,
	MoveDown: boolean | null,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{
			name: "DelayCodeId",
			value: DelayCodeId,
		},
		{ name: "MoveDown", value: MoveDown },
	];

	return await apiService.callV2("[DEL].[MoveDelayCode]", parameters);
};
